/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Upload, Icon} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, downLoadTemplate, toImportExcel, objectSerial, config} from 'Utils';
import {getProductList2, getProductCategory, del} from '../../service/product';

import {Store, Actions} from './store';

class ProductCustomerList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.state = {
            opts: ['其他产品管理'],
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            searchObj: {
                name: '',
                category: [],
                active: '',
                s: 10,
                p: 1,
                startCreatedDate: '',
                endCreatedDate: '',

            },
            categoryData: [],
            button_limits_end: {},
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.changeHandle = this.changeHandle.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.exportChange = this.exportChange.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
        // console.log(this.state.selectedRowKeys);

    }

    goView(url) {
        hashHistory.push(url);
    }

    /* 下载模板 */
    downTemplate() {
        downLoadTemplate(2);
    }

    goDelete() {
        const self = this;
        // del().then(function (result) {
        // 	if (result && result.code == 200) {
        // 		self.setState({
        // 			'rows': result.data || [],
        // 			'total': result.total
        // 		});
        // 	} else {
        // 		openNotice('error', '数据获取失败', '');
        // 	}
        // });

        // console.log( JSON.stringify(self.state.selectedRowKeys));
        // debugger

        del(JSON.stringify(self.state.selectedRowKeys)).then(function (result) {
            if (result && result.code == 200) {
                openNotice('warning', (result && result.message) ? result.message : '', '');
                self.initData();
            } else {
                openNotice('error', '删除失败', (result && result.message) ? result.message : '');
            }
        });
        self.setState({
            selectedRowKeys: [],
        });
    }

    changeHandle({item, key, keyPath}) {
        this.setState({key});
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                name: '',
                code: '',
                proType: '',
                supplier: '',
                category: [],
                active: '',
                priceStart: '',
                priceEnd: '',
                takeEffect: '',
                startCreatedDate: '',
                endCreatedDate: '',
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            },
            loading: true
        }, function () {
            self.initData();
        });
    };

    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}})
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        searchObj.removeFlag = 0;
        searchObj.categoryId = searchObj.category.length > 0 ? searchObj.category[searchObj.category.length - 1] : '';
        getProductList2(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    loading: false
                });
            } else {
                openNotice('error', '数据获取失败', '');
                this.setState({loading: false});
            }
        });
    }

    edit(record) {
        this.goView(`/productCustomer/add/${record.id}`);
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        let self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }
        getProductCategory().then(function (categoryResult) {
            /* 产品分类 */
            if (!categoryResult || categoryResult.code != 200) {
                openNotice('error', '产品分类数据获取失败，请重试', '');
                return;
            }
            self.setState({
                categoryData: categoryResult.data || []
            });
        });
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/trans/otherPro/exportOtherProduct?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    render() {
        const {opts, key, rows, total, searchObj, selectedRowKeys, categoryData, button_limits_end, loading} = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'code',
                    label: '物料编号',
                    text: '输入物料编号',
                    type: 'default',
                    defaultValue: searchObj.code
                }, {
                    name: 'name',
                    label: '物料描述',
                    text: '输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.name
                }, {
                    name: 'proType',
                    label: '物料类别',
                    text: '输入物料类别',
                    options: categoryData,
                    multiple: false,//支持多选
                    type: 'default',
                    defaultValue: searchObj.proType
                }, {
                    name: 'supplier',
                    label: '供应商',
                    text: '输入供应商',
                    type: 'default',
                    defaultValue: searchObj.supplier
                },
                {
                    name: 'priceStart',//startCreatedDate, endCreatedDate
                    label: '价格 从',
                    defaultValue: searchObj.priceStart
                    // type: 'default',
                },
                {
                    name: 'priceEnd',//startCreatedDate, endCreatedDate
                    label: '至',
                    defaultValue: searchObj.priceEnd
                    // type: 'default',
                },
                {
                    name: 'takeEffect',
                    label: '是否生效',
                    text: '选择是否生效',
                    options: [
                        {value: 'Y', text: '是'},
                        {value: 'N', text: '否'}
                    ],
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.takeEffect
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'code',
                    width: 120,
                }, {
                    title: '物料描述',
                    dataIndex: 'name',
                    width: 400
                }, {
                    title: '供应商',
                    dataIndex: 'supplier',

                }, {
                    title: '物料类别',
                    dataIndex: 'proType',
                }, {
                    title: '单位',
                    dataIndex: 'unit'
                }, {
                    title: '装箱数',
                    dataIndex: 'packageQuantity',

                }, {
                    title: '价格',
                    dataIndex: 'showPrice',
                    render: text => <span style={{color: '#d61518'}}>{'¥' + text}</span>
                }, {
                    title: '是否生效',
                    dataIndex: 'takeEffect',
                    render: text => text == 'Y' ? <span>是</span> : <span>否</span>
                }, {
                    title: '备注',
                    dataIndex: 'remark',
                    width: 400
                }, {
                    title: '创建时间',
                    dataIndex: 'createdDate',
                }, {
                    title: '操作',
                    render: (text, record, index) => <Button icon="edit" onClick={() => {
                        this.edit(record)
                    }}>编辑</Button>
                }
            ],
            scroll:{x:1700},// 添加滚动条
            rows,
            rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange
            }
        };
        const hasSelected = selectedRowKeys.length > 0;
        let uploadParam = toImportExcel(2, () => {
            this.initData();
        });
        return <div>
            <DmsTab options={opts} defaultKey={key} onChange={this.changeHandle}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content"><AdvanceFormNew  {...filterBoxProps} /></div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    {
                        button_limits_end.productCustomer_list_01
                        &&
                        <Upload {...uploadParam}>
                            <Button style={{position: 'absolute', bottom: 8, right: 0}}>
                                <Icon type="upload"/>导入
                            </Button>
                        </Upload>
                    }
                    {button_limits_end.productCustomer_list_01 &&
                    <Button onClick={this.downTemplate.bind(this)}
                            style={{position: 'absolute', bottom: 8, right: 176}}>下载模板</Button>}
                    {button_limits_end.productCustomer_list_01 &&
                    <Button style={{position: 'absolute', bottom: 8, right: 88}} icon="export"
                            onClick={this.exportChange}>导出</Button>}
                    {button_limits_end.productCustomer_list_02 &&
                    <Button icon="plus" onClick={this.goView.bind(this, `/productCustomer/add`)}
                            style={{position: 'absolute', bottom: 8, left: 0}}>新增</Button>}

                    {/*{button_limits_end.productCustomer_list_03 && <Button
                        type="primary"
                        onClick={this.goDelete.bind(this)}
                        disabled={!hasSelected}
                        icon="minus"
                    >删除</Button>}*/}
                </div>
                <TableView {...tableViewProps} />
            </div>
        </div>
    }
}
;
export default withRouter(ProductCustomerList);


// WEBPACK FOOTER //
// ./src/routes/productCustomer/list.js